export var DEFAULT_LIST_OFFSET = 0;
// This defines how many items retrieve when scroll infinite triggers load more items.
export var DEFAULT_LIMIT_AMOUNT = 20;
// We can use it to trigger 'onLoadMore' when the sentry comes near to become
// visible, instead of becoming fully visible on the screen.
export var ROOT_MARGIN_BOTTOM = '0px 0px 400px 0px';
export var DEFAULT_INPUT_DELAY = 500;
